export default __webpack_public_path__ + "static/media/Hexapod.089f7675.png";